import * as React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Button, IconButton, TextField, Tooltip } from "@mui/material";
import { Add, DeleteRounded, EditRounded, Search } from "@mui/icons-material";
import Card from "@mui/material/Card";
import UpdateBrand from "../UpdateBrand";
import AddBrand from "../AddBrand";
import axios from "axios";
import Success from "components/Success";
import Stack from "@mui/material/Stack";
import Grid2 from "@mui/material/Unstable_Grid2";
import {
  deleteCategoryApi,
  updateBrandApi,
  getAllBrandApi,
  addBrandApi,
  categoryApi,
} from "store/api";
import { useNavigate } from "react-router-dom";
import { allSubCategoryApi } from "store/api";

function TabPanel (props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps (index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function BrandTab () {
  const navigate = useNavigate();
  const [msg, setMsg] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [openUpdate, setOpenUpdate] = React.useState(false);
  const [openAdd, setOpenAdd] = React.useState(false);
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [category, setCategory] = React.useState([]);
  const [categories, setCategories] = React.useState([]);
  const [subCategories, setSubCategories] = React.useState([]);
  const [updateCategory, setUpdateCategory] = React.useState({});
  const [addCategoryImage, setAddCategoryImage] = React.useState({});
  const [categoryImage, setCategoryImage] = React.useState(false);
  const [updateCategoryImage, setUpdateCategoryImage] = React.useState({});
  const [addCategory, setAddCategory] = React.useState({
    name: "",
    slug: "",
    image: "",
    isActive: "",
    categoryOrder: 0,
    subCategoryIds: [],
  });
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const handleClickOpenUpdate = data => {
    setUpdateCategory(data);
    setOpenUpdate(true);
  };
  const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };

  const handleCloseUpdate = () => {
    setOpenUpdate(false);
    //   setOpen(true);
  };
  const handleCloseAdd = () => {
    setOpenAdd(false);
    //   setOpen(true);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const FetchBrand = async searchTerm => {
    setCategory([]);
    const params = !searchTerm
      ? {}
      : {
          searchKeyword: searchTerm,
        };
    try {
      const response = await getAllBrandApi(params);
      if (response?.success) {
        setCategory(response?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const FetchCategory = async searchTerm => {
    const params = !searchTerm
      ? {}
      : {
          searchKeyword: searchTerm,
        };
    try {
      const response = await categoryApi(params);
      if (response?.success) {
        setCategories(response?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };
  const FetchSubCategory = async () => {
    try {
      const response = await allSubCategoryApi();
      if (response?.success) {
        setSubCategories(response?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const [debounceTimeout, setDebounceTimeout] = React.useState(null);
  const handleChangeCategory = async e => {
    const { value } = e.target;
    // Clear the previous timeout
    if (debounceTimeout) clearTimeout(debounceTimeout);
    // Set a new timeout
    const newTimeout = setTimeout(() => {
      FetchBrand(value);
    }, 500); // Adjust debounce delay (500ms)

    setDebounceTimeout(newTimeout);
  };

  const handleSubmitUpdate = async (e, selectedSubCategories) => {
    e?.preventDefault();
    updateCategory.image = categoryImage;
    // if (subCategories.length) {
    //   updateCategory.subCategoryIds = subCategories.map(({ subCategoryId, isActive }) => ({
    //     subCategoryId,
    //     isActive,
    //   }));
    // }
    
    const response = await updateBrandApi(updateCategory);
    if (response?.success) {
      if (updateCategoryImage?.image) {
        let uploadUrl = response?.data?.uploadUrl;
        const uploadResponse = await axios.put(uploadUrl, updateCategoryImage?.image, {
          headers: { "Content-Type": updateCategoryImage?.image?.type },
        });
        if (uploadResponse?.status) {
          setMsg("Update Category Successfully");
          setSuccess(true);
          setOpenUpdate(false);
          setOpen(true);
          setUpdateCategoryImage({});
          FetchBrand();
        } else {
          setOpen(true);
          setOpenAdd(false);
          setSuccess(false);
          setMsg("Something went wrong in upload image. Please try again later.");
        }
      } else {
        setMsg("Update Category Successfully");
        setSuccess(true);
        FetchBrand();
        setOpenUpdate(false);
        setOpen(true);
      }
    } else {
      setOpen(true);
      setOpenAdd(false);
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
  };
  const handleSubmitAdd = async (e, selectedSubCategories) => {
    e?.preventDefault();
    if (subCategories.length) {
      addCategory.subCategoryIds = subCategories?.map(item => item.subCategoryId);
    }
    const response = await addBrandApi(addCategory);
    if (response?.success) {
      let uploadUrl = response?.data?.uploadUrl;
      const uploadResponse = await axios.put(uploadUrl, addCategoryImage?.image, {
        headers: { "Content-Type": addCategoryImage?.image?.type },
      });
      if (uploadResponse?.status) {
        setMsg("Add Category Successfully");
        setSuccess(true);
        setOpenAdd(false);
        setOpen(true);
        FetchBrand();
      }
    } else {
      setOpen(true);
      setOpenAdd(false);
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
  };

  const handleChangeUpdateCategory = e => {
    const { name, value } = e.target;
    setUpdateCategory(prev => ({
      ...prev,
      [name]:
        name == "subCategoryIds"
          ? updateCategory?.subCategoryIds?.length
            ? [...updateCategory.subCategoryIds, { subCategoryId: value, isActive: true }]
            : [{ subCategoryId: value, isActive: true }]
          : value,
    }));
  };
  const handleChangeAddCategory = e => {
    const { name, value } = e.target;
    setAddCategory(prev => ({
      ...prev,
      [name]:
        name == "subCategoryIds"
          ? addCategory?.subCategoryIds?.length
            ? [...addCategory.subCategoryIds, { subCategoryId: value, isActive: true }]
            : [{ subCategoryId: value, isActive: true }]
          : value,
    }));
  };
  const handleChangeAddCategoryImage = e => {
    setCategoryImage(false)
    const { name, value } = e.target;
    setAddCategoryImage({
      [name]: e.currentTarget?.files[0],
    });
    setCategoryImage(true)
  };
  const handleChangeUpdateCategoryImage = e => {
    setCategoryImage(false)
    const { name, value } = e.target;
    setUpdateCategoryImage({
      [name]: e.currentTarget?.files[0],
    });
    setCategoryImage(true)
  };

  const DeleteCategory = async categoryId => {
    const params = {
      categoryId: categoryId,
    };
    const response = await deleteCategoryApi(params);
    if (response?.success) {
      setMsg("Delete Category Successfully");
      setSuccess(true);
      FetchBrand();
      setOpenAdd(false);
    } else {
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    setOpen(true);
  };

  React.useEffect(() => {
    FetchBrand();
    FetchCategory();
    FetchSubCategory();
  }, []);

  return (
    <div
      style={{
        padding: "20px",
        marginTop: "20px",
        marginBottom: "30px",
        backgroundColor: "",
        border: "",
        borderRadius: "12px",
        boxShadow: "0 0 8px 1px rgba(0,0,0,0.25)",
        color: "",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Typography variant='h5'>Brand</Typography>
        <Button
          variant='contained'
          startIcon={<Add />}
          color='success'
          onClick={() => handleClickOpenAdd()}
          //   style={{ backgroundColor: "", color: "white", textTransform: "none" }}
        >
          Add New Brand
        </Button>
      </div>

      {/* Search and Rows Per Page */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "20px",
        }}
      >
        <TextField
          placeholder='Search here...'
          InputProps={{
            endAdornment: (
              <IconButton color='inherit'>
                <Search />
              </IconButton>
            ),
          }}
          onChange={handleChangeCategory}
          style={{ backgroundColor: "", borderRadius: "4px" }}
        />
      </div>

      <Box>
        <AppBar position='static'>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor='secondary'
            textColor='inherit'
            variant='fullWidth'
            aria-label='full width tabs example'
          >
            <Tab label='All Brand' {...a11yProps(0)} />
            <Tab label='Active Brand' {...a11yProps(1)} />
            <Tab label='Disable Brand' {...a11yProps(2)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Grid2 container py={3} spacing={3}>
            {category?.length == 0 && <div>No brand found</div>}
            {category?.length > 0 &&
              category?.map(e => (
                <Category
                  category={e}
                  DeleteCategory={DeleteCategory}
                  handleClickOpenUpdate={handleClickOpenUpdate}
                />
              ))}
          </Grid2>
        </TabPanel>

        <TabPanel value={value} index={1} dir={theme.direction}>
          <Grid2 container py={3} spacing={3}>
            {category?.length == 0 && <div>No brand found</div>}
            {category?.length > 0 &&
              category?.map(
                e =>
                  e.isActive && (
                    <Category
                      category={e}
                      DeleteCategory={DeleteCategory}
                      handleClickOpenUpdate={handleClickOpenUpdate}
                    />
                  )
              )}
          </Grid2>
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          <Grid2 container py={3} spacing={3}>
            {category?.length == 0 && <div>No brand found</div>}
            {category?.length > 0 &&
              category?.map(
                e =>
                  !e.isActive && (
                    <Category
                      category={e}
                      DeleteCategory={DeleteCategory}
                      handleClickOpenUpdate={handleClickOpenUpdate}
                    />
                  )
              )}
          </Grid2>
        </TabPanel>
      </Box>
      <UpdateBrand
        open={openUpdate}
        category={categories}
        handleClose={handleCloseUpdate}
        handleSubmit={handleSubmitUpdate}
        updateCategoryData={updateCategory}
        updateCategoryImage={updateCategoryImage}
        handleChangeUpdateCategory={handleChangeUpdateCategory}
        handleChangeUpdateCategoryImage={handleChangeUpdateCategoryImage}
      />
      <AddBrand
        open={openAdd}
        category={categories}
        handleClose={handleCloseAdd}
        addCategoryData={addCategory}
        handleSubmit={handleSubmitAdd}
        addCategoryImage={addCategoryImage}
        handleChangeAddCategory={handleChangeAddCategory}
        handleChangeAddCategoryImage={handleChangeAddCategoryImage}
      />
      <Success open={open} success={success} msg={msg} handleClose={handleClose} />
    </div>
  );
}

const Category = ({ category, DeleteCategory, handleClickOpenUpdate }) => {
  const navigate = useNavigate();
  return (
    <Grid2 xs={12} sm={6} md={3} style={{ border: "16px", overflow: "hidden" }}>
      <Card>
        <Box sx={{ pt: "100%", position: "relative" }}>
          <div
            style={{
              zIndex: 9,
              top: 10,
              right: 10,
              position: "absolute",
              textTransform: "uppercase",
              display: "flex",
              gap: "10px",
            }}
          >
            <Tooltip title={"Edit"} onClick={() => handleClickOpenUpdate(category)}>
              <EditRounded style={{ fontSize: "16px", fill: "black", cursor: "pointer" }} />
            </Tooltip>
          </div>

          <Box
            component='img'
            alt='brand'
            src={category.image}
            sx={{
              top: 0,
              width: 1,
              height: 1,
              zIndex: 0,
              objectFit: "cover",
              position: "absolute",
              borderRadius: "16px 16px 0 0",
            }}
          />
        </Box>

        <Stack spacing={2} sx={{ px: 3, py: 2, cursor: "pointer" }}>
          <Box
            color='inherit'
            underline='hover'
            variant='subtitle2'
            style={{ fontSize: "0.875rem", fontWeight: "500" }}
            noWrap
            // onClick={() => navigate(`/sub-category?id=${category.categoryId}`)}
          >
            <div style={{ fontSize: "20px" }}>{category?.name}</div>
            {/* <div>Slug: {category?.slug}</div> */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                fontSize: "0.875rem",
              }}
            >
              {/* <div>Order: {category?.categoryOrder}</div> */}
              <div>Active: {category.isActive ? "🟢" : "🔴"}</div>
            </div>
          </Box>
        </Stack>
      </Card>
    </Grid2>
  );
};
